<template>
  <div class="m-edition-map-tasks-list">
    <MoleculeEditionMapTasksListSubMenu
      :loading="showLoadingState"
      :submenu-item="filter.estado"
      :pending-tasks-amount="pendingTasksAmount"
      @changeTaskList="changeTaskList"
    />

    <p
      v-if="showLoadingState"
      class="margin-top-xxlarge text-align-center"
    >
      Cargando datos...
    </p>
    <p
      v-else-if="!showLoadingState && tasks.length === 0"
      class="margin-top-xxlarge text-align-center"
    >
      No hay tareas {{ states[filter.estado] }}.
    </p>

    <ul
      v-if="tasks.length"
      class="m-edition-map-tasks-list-items"
    >
      <li
        v-for="task in tasks"
        :key="task.nodo_activo_tarea"
      >
        <a
          href="#"
          :class="selectedTaskId === task.nodo_activo_tarea ? 'selected-task' : ''"
          @click.prevent="goToTask(task)"
        >
          <span>
            <img
              class="a-avatar-primary"
              :src="task.avatar"
            />
          </span>
          <span class="task-info">
            <span class="task-info-student">{{ task.razon_social }}</span>
            <span class="task-info-node">{{ task.nodo_titulo }}</span>
          </span>
          <span
            v-if="filter.estado === 0"
            key="taskPendingState"
            class="task-state task-state-pending"
          >
            <i class="far fa-clock"></i>
          </span>
          <span
            v-else-if="filter.estado === 1"
            key="taskCompletedState"
            class="task-points"
          >
            <span class="margin-right-xsmall">{{ task.puntaje }}</span>
            <i class="fas fa-star text-color-notifications-primary"></i>
          </span>
          <span
            v-else
            key="taskRejectedState"
            class="task-state task-state-rejected"
          >
            <i class="far fa-times"></i>
          </span>
        </a>
      </li>
    </ul>
    <MoleculePaginationSecondary
      v-if="!showLoadingState"
      :pagination="pagination"
      @setPaginationCurrentPage="setPaginationCurrentPage"
    />
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapTasksList',

  components: {
    MoleculeEditionMapTasksListSubMenu: () => import('@/components/molecules/MoleculeEditionMapTasksListSubMenu'),
    MoleculePaginationSecondary: () => import('@/components/molecules/MoleculePaginationSecondary')
  },

  props: {
    shouldReadTasksList: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      academiaId: '',

      filter: {
        estado: 0,
        limite: 10,
        pagina: 1
      },

      pagination: {
        currentPage: 1,
        limit: 10,
        showLoadingState: false,
        totalPages: 0
      },

      pendingTasksAmount: 0,
      showLoadingState: false,
      states: ['pendientes', 'completadas', 'rechazadas'],
      tasks: []
    }
  },

  computed: {
    selectedTaskId () {
      return this.$store.getters.getAssetSelectedTaskInList.nodo_activo_tarea
    }
  },

  watch: {
    'filter': {
      deep: true,

      handler () {
        this.tasks = []
        this.$store.commit('setAssetSelectedTask', {})
        this.$store.commit('setAssetSelectedTaskInList', {})
        this.readInscripcionNodosActivosTareas()
      }
    },

    shouldReadTasksList () {
      this.readInscripcionNodosActivosTareas()
    }
  },

  created () {
    this.$store.commit('setAssetSelectedTask', {})
    this.$store.commit('setAssetSelectedTaskInList', {})
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readInscripcionNodosActivosTareas()
  },

  methods: {
    changeTaskList (item) {
      if (this.filter.estado !== item) {
        this.tasks = []
        this.$store.commit('setAssetSelectedTaskInList', {})
        this.$store.commit('setAssetSelectedTask', {})
        this.filter.estado = item
      }
    },

    goToTask (task) {
      this.$store.commit('setAssetSelectedTaskInList', Object.assign({}, task))
    },

    readInscripcionNodosActivosTareas () {
      this.showLoadingState = true
      this.$services.read('inscripcion', 'readInscripcionNodosActivosTareas', {}, [this.academiaId,
        this.$route.params.id], this.filter)
        .then(response => {
          console.log(response.data)
          this.tasks = [...response.data.tareas]
          this.$store.commit('setAssetSelectedTaskInList', Object.assign({}, this.tasks[0]))
          this.pagination.totalPages = response.data.pages
          this.pagination.showLoadingState = false
          this.pendingTasksAmount = this.filter.estado === 0
            ? response.data.total
            : this.pendingTasksAmount
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.pagination.totalPages = 0
          this.pagination.showLoadingState = false
          this.pendingTasksAmount = 0
          this.showLoadingState = false
        })
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
    }
  }
}
</script>
